import React from 'react';
import styled from 'styled-components';

const VoiceDrawContainer = styled.div`
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #6b46c1 0%, #4338ca 25%, #1e1b4b 75%, #000000 100%);
  padding: 0;
  margin: 0;
  overflow: hidden;
`;

const VoiceDrawFrame = styled.iframe`
  width: 100%;
  height: calc(100vh - 80px);
  border: none;
  background: white;
`;

const VoiceDrawApp: React.FC = () => {
  return (
    <VoiceDrawContainer>
      <VoiceDrawFrame
        src="/voice-draw/index.html"
        title="Voice Drawing App"
      />
    </VoiceDrawContainer>
  );
};

export default VoiceDrawApp;
